export namespace UserRoles {
  /**
   * Внутренние роли
   */
  export enum Internal {
    /**
     * РП- руководитель партнёра
     */
    PARTNER_MANAGER = 'partner_manager',

    /**
     * зам - РП- руководитель партнёра
     */
    VICE_PARTNER_MANAGER = 'vice_partner_manager',

    /**
     * МЗ - менеджер по закупкам
     */
    PURCHASING_MANAGER = 'purchasing_manager',

    /**
     * МП - менеджер по продажам
     */
    SALE_MANAGER = 'sale_manager',

    /**
     * МП(ФП) - менеджер по продажам(фулл-прайс)
     */
    SALE_MANAGER_FULL_PRICE = 'sale_manager_full_price',

    /**
     СМ - Сервис-менеджер
     */
    SERVICE_MANAGER = 'service_manager',

    /**
     * И - Инженер
     */
    ENGINEER = 'engineer',

    /**
     * М - маркетолог
     */
    MARKETER = 'marketer',

    /**
     * СИ - Сервисный инженер
     */
    SERVICE_ENGINEER = 'service_engineer',

    /**
     * МК - Менеджер по управлению клиентами
     */
    CLIENT_MANAGER = 'client_manager',

    /**
     * СМ (Новые регионы) - Сервис-менеджер (Новые регионы)
     */
    SERVICE_MANAGER_NEW_REGIONS = 'service_manager_new_regions',

    /**
      * МПК - менеджер по кредитованию
      */
    CREDIT_MANAGER = 'credit_manager',
  }

  /**
   * Внешние роли / Админы
   */
  export enum External {
    /**
     * IT-администратор
     */
    IT_ADMIN = 'it_admin',

    /**
     * Администратор
     */
    ADMIN = 'admin',

    /**
     * Маркетинг-менеджер
     */
    MARKETING_MANAGER = 'marketing_manager',
  }
}

export const UserRolesTranslate: Record<string, string> = {
  [UserRoles.Internal.PARTNER_MANAGER]: 'Руководитель партнёра',
  [UserRoles.Internal.VICE_PARTNER_MANAGER]: 'Заместитель руководителя партнёра',
  [UserRoles.Internal.PURCHASING_MANAGER]: 'Менеджер по закупкам',
  [UserRoles.Internal.SALE_MANAGER]: 'Менеджер по продажам',
  [UserRoles.Internal.SALE_MANAGER_FULL_PRICE]: 'Менеджер по продажам (полн.прайс)',
  [UserRoles.Internal.SERVICE_MANAGER]: 'Сервис-менеджер',
  [UserRoles.Internal.ENGINEER]: 'Инженер',
  [UserRoles.Internal.MARKETER]: 'Маркетолог',
  [UserRoles.Internal.SERVICE_ENGINEER]: 'Сервисный инженер',
  [UserRoles.Internal.CLIENT_MANAGER]: 'Менеджер по управлению клиентами',
  [UserRoles.Internal.SERVICE_MANAGER_NEW_REGIONS]: 'Сервис-менеджер (Новые регионы)',
  [UserRoles.Internal.CREDIT_MANAGER]: 'Менеджер по кредитованию',
};

export const UserRolesSelect = Object.values(UserRoles.Internal).slice(1).map((role) => ({
  value: role,
  text: UserRolesTranslate[role],
}));

export const AllUserRolesSelect = Object.values(UserRoles.Internal).map((role) => ({
  value: role,
  text: UserRolesTranslate[role],
}));
